import { MobileView } from "react-device-detect";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import larlogo from "../assets/logo-beta.png";

function SignupMessage() {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      mobileView: {
        padding: "200px 40px 507px 40px",
        width: 393,
        height: 851
      },
      mobileLogoBox: {
        display: "flex",
        justifyContent: "center",
      },
      mobileLogo: {
        width: 101,
        height: 43,
        flexGrow: 0,
        padding: "0 0 1.4px",
      },
      contentSection1: {
        marginTop: 43.4,
        fontSize: 24,
        fontWeight: 600,
        textAlign: "center",
      },
      contentSection2:{
        marginTop:24,
        fontSize:20,
        fontWeight: 500,
        lineHeight: 1.25,
        textAlign: "center",
      }
    })
  );
  const classes = useStyles();

  return (
    <MobileView className={classes.mobileView}>
      <div className={classes.mobileLogoBox}>
        <img alt="logo" className={classes.mobileLogo} src={larlogo} />
      </div>
      <div className={classes.contentSection1}>
        <p>Thank you for signing up for Sotira!</p>
      </div>
      <div className={classes.contentSection2}>
        <p>Please <a href="/auth/login" style={{color:"#48b7a7" ,fontWeight:"bold"}}>login</a> on desktop to continue setting up your account.</p>
      </div>
    </MobileView>
  );
}

export default SignupMessage;
